import Rollbar from 'rollbar';
import {
  getErrorEnvironment,
  getRollbarEnvironment,
  reportToRollbar,
} from '../../Utils/Logger';
import {
  hasExceededDailyMaxItems,
  increaseDailyItemsCounter,
} from '../../Utils/LoggerRateLimitUtils';

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: '1b511f912af44f32ba2daec757abbe0a',
  transmit: false, //skicka inte till rollbar. Den här inställningen ändras efter att cookie-inställningar lästs in om användaren godkänt att vi rapporterar fel till rollbar.
  captureUncaught: reportToRollbar(),
  verbose: true, // This will log everything that is sent to Rollbar to console.log
  payload: {
    environment: getRollbarEnvironment(),
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: config.version,
      },
    },
  },
  // Only send a max of 10 items to Rollbar per minute
  itemsPerMinute: 10,
  // Only send a maximum of 100 items to Rollbar per page load
  maxItems: 100,
  // Removes hostname from stack trace filenames
  transform: function (payload: unknown) {
    const payloadRecord = payload as Record<string, unknown>;
    const body = typeof payloadRecord?.['body'] === 'object'
      ? (payloadRecord['body'] as Record<string, unknown>)
      : undefined;
    const trace = body?.['trace'] as Record<string, unknown> | undefined;
    const frames: Record<string, unknown>[] | undefined = Array.isArray(trace?.['frames'])
      ? (trace['frames'] as Record<string, unknown>[])
      : undefined;
    const locRegex = /\/js\/.*/;
    if (frames) {
      for (let i = 0; i < frames.length; i++) {
        const filename: unknown = frames[i]?.['filename'];
        if (typeof filename === 'string' && filename) {
          const m = filename.match(locRegex);
          if (m != null) {
            frames[i]['filename'] = m[0];
          }
        }
      }
    }
  },
  checkIgnore: (isUncaught: boolean, args: any, payload: any) => {
    const isLoggedInError =
      typeof args?.[0]?.message === 'string'
        ? args?.[0]?.message.toLowerCase().includes('login required')
        : false;

    const value = hasExceededDailyMaxItems();
    const level = payload && payload.level ? payload.level : undefined;
    return level === 'critical' ? false : value || isLoggedInError;
  },
  onSendCallback: (isUncaught: boolean, args: any, payload: any) => {
    increaseDailyItemsCounter();

    const errorEnv = getErrorEnvironment();
    if (errorEnv.rutin) {
      payload.body.avenyRutin = errorEnv.rutin;
      payload.body.avenyDelsystem = errorEnv.delsystem;
    }

    if (payload.body.message?.body) {
      payload.body.message.body = `${payload.body.message.body} (frontend)`;
      if (isUncaught) {
        payload.body.message.body = `${payload.body.message.body} (ohanterat)`;
      }
    }
  },
};

export const rollbar = new Rollbar(rollbarConfig);
(window as unknown as Record<string, unknown>)['Rollbar'] = rollbar;
